module.exports = __webpack_public_path__ + "static/media/Ellen Hopkins Bradley Headshot.eea7b6d9.jpeg";